export default __webpack_public_path__ + "static/media/interiorcase.d7071561.pdf";